import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Chip } from '@scramble/ui';
import { safeDecimal } from '@scramble/utils';
import s from './index.module.scss';

const PERCENTS = [25, 50, 75, 100];

export const AmountPresets = ({ amount, availableAmount, className, onClick }) => {
  const { t } = useTranslation();

  const presets = useMemo(() => {
    const amount = Number(availableAmount) || 0;
    return PERCENTS.map(percent => {
      const calculatedAmount = safeDecimal(amount * (percent / 100)).toNumber().toFixed(2);
      return {
        label:
          percent === 100 ? t('withdraw:amount_presets.max') : `${percent}%`,
        value: Number(calculatedAmount),
      };
    }).filter(item => item.value > 0.01);
  }, [availableAmount, t]);

  return (
    <div className={classnames(s.presets, className)}>
      {presets.map(preset => (
        <Chip
          size="medium"
          key={preset.label}
          selected={preset.value === Number(amount)}
          onClick={() => {
            onClick(preset.value);
          }}
        >
          {preset.label}
        </Chip>
      ))}
    </div>
  );
};
